import React, { Fragment } from "react";

import ExpandableSection from "./ExpandableSection";
import FilterGroup from "./FilterGroup";
import FilterMenuMaxHeightBox from "./FilterMenuMaxHeightBox";
import Line from "./Line";
import SmallCaps from "./SmallCaps";
import PropTypes from "prop-types";

const DropdownFilterWidget = ({ filter }) => {
  return (
    <Fragment>
      <ExpandableSection
        heading={<SmallCaps>{filter.label}</SmallCaps>}
        content={
          <FilterMenuMaxHeightBox>
            <FilterGroup type={filter.type} options={filter.options} />
          </FilterMenuMaxHeightBox>
        }
      />
      <Line />
    </Fragment>
  );
};

export default DropdownFilterWidget;

DropdownFilterWidget.propTypes = {
  filter: PropTypes.shape({
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
};
